// types
// ui
export const LOADER_GLOBAL_SHOW = 'LOADER_GLOBAL_SHOW'
export const LOADER_GLOBAL_HIDE = 'LOADER_GLOBAL_HIDE'
export const RESIZE_WINDOW = 'RESIZE_WINDOW'
export const ORIENTATION_CHANGE = 'ORIENTATION_CHANGE'

// panels
export const TOGGLE_PANEL_DETAIL_OPEN = 'TOGGLE_PANEL_DETAIL_OPEN' // transition start to open
export const TOGGLE_PANEL_DETAIL_IS_OPEN = 'TOGGLE_PANEL_DETAIL_IS_OPEN' // transition end, is open
export const TOGGLE_PANEL_LEFT_OPEN = 'TOGGLE_PANEL_LEFT_OPEN' // transition start to open
export const TOGGLE_PANEL_LEFT_IS_OPEN = 'TOGGLE_PANEL_LEFT_IS_OPEN' // transition end, is open
export const TOGGLE_PANEL_DETAIL_CONTENT_IS_OPEN = 'TOGGLE_PANEL_DETAIL_CONTENT_IS_OPEN' // NO transition end callback

export const TOGGLE_PANEL_START_OVERLAY_OPEN = 'TOGGLE_PANEL_START_OVERLAY_OPEN' // init transition
export const TOGGLE_PANEL_START_OVERLAY_IS_OPEN = 'TOGGLE_PANEL_START_OVERLAY_IS_OPEN' // transition end callback
export const TOGGLE_PANEL_FULL_OVERLAY_AUTOCOMPLETE_NORESULT_IS_OPEN = 'TOGGLE_PANEL_FULL_OVERLAY_AUTOCOMPLETE_NO_RESULT_IS_OPEN' // NO transition end callback

export const SET_PANEL_HEADER_HEIGHT = 'SET_PANEL_HEADER_HEIGHT'

// open instances
export const TOGGLE_INSTANCE_AUTOCOMPLETE_MAIN_HEADER_OPEN = 'TOGGLE_INSTANCE_AUTOCOMPLETE_MAIN_HEADER_OPEN'
export const TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_LEFT_OPEN = 'TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_LEFT_OPEN'
export const TOGGLE_INSTANCE_AUTOCOMPLETE_START_OVERLAY_OPEN = 'TOGGLE_INSTANCE_AUTOCOMPLETE_START_OVERLAY_OPEN'
export const TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_DETAIL_STATION_OPEN = 'TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_DETAIL_STATION_OPEN'

// data
export const SET_MAP_LOADED = 'SET_MAP_LOADED';
export const SET_MAP_UNLOADED = 'SET_MAP_UNLOADED'
export const SET_JSON_LOADED = 'SET_JSON_LOADED';

// intern
export const INTERN_SET_IS_INITIAL_CONFIG_REQUEST_DONE = 'INTERN_SET_IS_INITIAL_CONFIG_REQUEST_DONE'
export const INTERN_SET_IS_AUTHENTICATED = 'INTERN_SET_IS_AUTHENTICATED'

// intern_ui
export const INTERN_TOGGLE_PANEL_LEFT_OPEN = 'INTERN_TOGGLE_PANEL_LEFT_OPEN'
export const INTERN_TOGGLE_MODAL_COLOR_OPEN = 'INTERN_TOGGLE_MODAL_COLOR_OPEN'
export const INTERN_TOGGLE_MODAL_ORIGIN_DESTINATION_OPEN = 'INTERN_TOGGLE_MODAL_ORIGIN_DESTINATION_OPEN'

// intern_config
export const INTERN_TOGGLE_SHOW_SMALL_STATION_LABELS = 'INTERN_TOGGLE_SHOW_SMALL_STATION_LABELS'
export const INTERN_TOOGLE_SHOW_MEDIUM_STATION_LABELS = 'INTERN_TOOGLE_SHOW_MEDIUM_STATION_LABELS'
export const INTERN_TOGGLE_SHOW_LARGE_STATION_LABELS = 'INTERN_TOGGLE_SHOW_LARGE_STATION_LABELS'
export const INTERN_TOGGLE_SHOW_LINE_LABELS = 'INTERN_TOGGLE_SHOW_LINE_LABELS'
export const INTERN_TOGGLE_OVERRIDE_COLOR = 'INTERN_TOGGLE_OVERRIDE_COLOR'
// mode_step: only relevant for mode origin_destination, step origin ist set on modal open, see reducer
// so only set to destination needs an action. Reset ist handled on closing the modal
export const INTERN_SET_ORIGIN_STATION_CODE = 'INTERN_SET_ORIGIN_STATION_CODE'

// intern "special" actions
// resets everything
export const INTERN_RESET_ALL = 'INTERN_RESET_ALL'


// functions

// ui
export const loader_global_show = () => {
	return { type: LOADER_GLOBAL_SHOW };
}

export const loader_global_hide = () => {
	return { type: LOADER_GLOBAL_HIDE };
}

export const resize_window = (width, height, client_type) => {
	return { type: RESIZE_WINDOW, width: width, height: height, client_type: client_type };
}

export const orientation_change = (orientation) => {
	return { type: ORIENTATION_CHANGE, orientation: orientation };
}

// panels

export const toggle_panel_detail_open = (panel_detail_open) => {
	return { type: TOGGLE_PANEL_DETAIL_OPEN, panel_detail_open: panel_detail_open }
}

export const toggle_panel_detail_is_open = (panel_detail_is_open, panel_detail_space) => {
	return { type: TOGGLE_PANEL_DETAIL_IS_OPEN, panel_detail_is_open: panel_detail_is_open, panel_detail_space:  panel_detail_space}
}

export const toggle_panel_left_open = (panel_left_open) => {
	return { type: TOGGLE_PANEL_LEFT_OPEN, panel_left_open: panel_left_open }
}

export const toggle_panel_left_is_open = (panel_left_is_open, panel_left_space) => {
	return { type: TOGGLE_PANEL_LEFT_IS_OPEN, panel_left_is_open: panel_left_is_open, panel_left_space: panel_left_space }
}

// content collapsible/expandable on mobile (showing Map when collapsed)
export const toggle_panel_detail_content_is_open = (panel_detail_content_is_open) => {
	return { type: TOGGLE_PANEL_DETAIL_CONTENT_IS_OPEN, panel_detail_content_is_open: panel_detail_content_is_open}
}


export const toggle_panel_start_overlay_open = (panel_start_overlay_open) => {
	return { type: TOGGLE_PANEL_START_OVERLAY_OPEN, panel_start_overlay_open: panel_start_overlay_open }
}

export const toggle_panel_start_overlay_is_open = (panel_start_overlay_is_open) => {
	return { type: TOGGLE_PANEL_START_OVERLAY_IS_OPEN, panel_start_overlay_is_open: panel_start_overlay_is_open }
}

export const toggle_panel_full_overlay_autocomplete_noresult_is_open = (panel_full_overlay_autocomplete_noresult_is_open) => {
	return { type: TOGGLE_PANEL_FULL_OVERLAY_AUTOCOMPLETE_NORESULT_IS_OPEN, panel_full_overlay_autocomplete_noresult_is_open: panel_full_overlay_autocomplete_noresult_is_open }
}


export const set_panel_header_height = (panel_header_height) => {
	return { type: SET_PANEL_HEADER_HEIGHT, panel_header_height: panel_header_height }
}


// open instances
export const toggle_instance_autocomplete_main_header_open = (autocomplete_main_header_open) => {
	return { type: TOGGLE_INSTANCE_AUTOCOMPLETE_MAIN_HEADER_OPEN, autocomplete_main_header_open: autocomplete_main_header_open }
}
export const toggle_instance_autocomplete_panel_left_open = (autocomplete_panel_left_open) => {
	return { type: TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_LEFT_OPEN, autocomplete_panel_left_open: autocomplete_panel_left_open }
}
export const toggle_instance_autocomplete_start_overlay_open = (autocomplete_start_overlay_open) => {
	return { type: TOGGLE_INSTANCE_AUTOCOMPLETE_START_OVERLAY_OPEN, autocomplete_start_overlay_open: autocomplete_start_overlay_open }
}
export const toggle_instance_autocomplete_panel_detail_station_open = (autocomplete_panel_detail_station_open) => {
	return { type: TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_DETAIL_STATION_OPEN, autocomplete_panel_detail_station_open: autocomplete_panel_detail_station_open }
}

// data

export const set_map_loaded = () => {
	return { type: SET_MAP_LOADED };
}

export const set_map_unloaded = () => {
	return { type: SET_MAP_UNLOADED };
}

export const set_json_loaded = () => {
	return { type: SET_JSON_LOADED };
}

// intern

export const intern_is_initial_config_request_done = () => {
	return { type: INTERN_SET_IS_INITIAL_CONFIG_REQUEST_DONE }
}

export const intern_set_is_authenticated = (is_authenticated) => {
	return { type: INTERN_SET_IS_AUTHENTICATED, is_authenticated: is_authenticated }
}


// intern_ui

export const intern_toggle_panel_left_open = (panel_left_open) => {
	return { type: INTERN_TOGGLE_PANEL_LEFT_OPEN, panel_left_open: panel_left_open }
}

export const intern_toggle_modal_color_open = (modal_color_open) => {
	return { type: INTERN_TOGGLE_MODAL_COLOR_OPEN, modal_color_open: modal_color_open }
}

export const intern_toggle_modal_origin_destination_open = (modal_origin_destination_open) => {
	return { type: INTERN_TOGGLE_MODAL_ORIGIN_DESTINATION_OPEN, modal_origin_destination_open: modal_origin_destination_open }
}

// intern_config

export const intern_toggle_show_small_station_labels = (show_small_station_labels) => {
	return { type: INTERN_TOGGLE_SHOW_SMALL_STATION_LABELS, show_small_station_labels: show_small_station_labels }
}

export const intern_toggle_show_medium_station_labels = (show_medium_station_labels) => {
	return { type: INTERN_TOOGLE_SHOW_MEDIUM_STATION_LABELS, show_medium_station_labels: show_medium_station_labels }
}

export const intern_toggle_show_large_station_labels = (show_large_station_labels) => {
	return { type: INTERN_TOGGLE_SHOW_LARGE_STATION_LABELS, show_large_station_labels: show_large_station_labels }
}

export const intern_toggle_show_line_labels = (show_line_labels) => {
	return { type: INTERN_TOGGLE_SHOW_LINE_LABELS, show_line_labels: show_line_labels }
}

export const intern_toggle_override_color = (override_color_bg, override_color_label) => {
	return { type: INTERN_TOGGLE_OVERRIDE_COLOR, override_color_bg: override_color_bg, override_color_label: override_color_label }
}

export const intern_set_origin_destination_code = (origin_station_code) => {
	return { type: INTERN_SET_ORIGIN_STATION_CODE, origin_station_code: origin_station_code }
}

// intern "special" actions

export const intern_reset_all = () => {
	return { type: INTERN_RESET_ALL }
}
